import React from 'react';
import { useTranslation } from 'react-i18next';
import video_mobile from "../../images/video/VIDEO_MOB_2_DOTATION.webm"
import video_desktop from "../../images/video/VIDEO_WEB.webm"
import video_mobile_mp4 from "../../images/video/VIDEO_MOB_2_DOTATION.mp4"
import video_desktop_mp4 from "../../images/video/VIDEO_WEB.mp4"

const Dotation = () => {

  const { t } = useTranslation();

  return (
    <div className={"strate"} id={"dotationStrate"}>
      <h1 className={"albra"} dangerouslySetInnerHTML={{ __html: t("dotation_a_gagner") }} />

      <div className={"subtitle"} dangerouslySetInnerHTML={{ __html: t("dotation_activites_et_cartes_cadeaux") }} />

      <video controls={true} muted={true} autoPlay={true} loop={true} className={"d-lg-none"} playsInline={true}>
        <source src={video_mobile} />
        <source src={video_mobile_mp4} />
      </video>

      <video controls={true} muted={true} autoPlay={true} loop={true} className={"d-none d-lg-inline"} playsInline={true}>
        <source src={video_desktop} />
        <source src={video_desktop_mp4} />
      </video>


    </div>
  );
};

export default Dotation;
